import { render, staticRenderFns } from "./MindoComment.vue?vue&type=template&id=38b89975&"
import script from "./MindoComment.vue?vue&type=script&lang=js&"
export * from "./MindoComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports